/**
 * Central registry of `localStorage` keys. A caller reaches for a key here instead of posing its
 * own string literal, so every key the application writes to the device stays visible in one place.
 */
export const LOCAL_STORAGE_KEYS = {
	INSTALL_BANNER_DISMISSAL_STATE: 'INSTALL_BANNER_DISMISSAL_STATE',
	CURRENT_FACILITY_ID: 'CURRENT_FACILITY_ID',
	CURRENT_ORGANIZATION_ID: 'CURRENT_ORGANIZATION_ID',
	DEVICE_RETENTION_MS: 'DEVICE_RETENTION_MS',
	DISPLAYED_LOGO: 'DISPLAYED_LOGO',
} as const;

export type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];
